<template>
  <div class="mian" ref="box">
    <div class="header">
      <div class="logo">炼石科技</div>
      <div>
        <el-input v-model="input" placeholder="请输入内容">
          <el-button type="primary" icon="el-icon-search" circle slot="append"></el-button>
        </el-input>
      </div>
    </div>
    <div class="fgx"></div>
    <div class="listBox">
      <div class="hoverBox" v-for="item in listData" :key="item.id">
        <div class="itemBox" @click="hanldeItem(item.id)">
          <div class="itemImg">
            <img :src="'https://www.cdsszwhg.com' + item.imgpath1" alt="">
          </div>
          <div class="itemTitle">{{ item.simpletitle }}</div>
          <div class="itemDate">时间：{{ formatTime(item.publishtime, 'yyyy年MM月DD日') }}</div>
          <div class="itemDate">地点：{{ item.address }}</div>
        </div>
      </div>
    </div>
    <div class="load" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="加载中...">
    </div>
    <div class="footer">
      <div class="as"><a href="https://beian.miit.gov.cn/"
          target="_blank">蜀ICP备17003512号-1</a>&nbsp;&nbsp;by&nbsp;&nbsp;炼石科技</div>
    </div>
  </div>
</template>

<script>
import { api } from "@/api/index.js"
import { formatTime } from "@/tools/index.js"
// import { getToken } from "@/api/request.js"
export default {
  data() {
    return {
      // getToken,
      formatTime,
      loading: false,
      input: "",
      listData: [],
      pages: 1,
      pageSize: 12,
      page_count: 1, // 总页数
    }
  },
  created() {
    // this.getList()
    // if (!localStorage.getItem("token")) {
    //   await this.getToken()
    // }
    this.getList()
  },
  mounted() {
    window.addEventListener('scroll', this.lazyLoading); // 滚动到底部，再加载的处理事件
  },
  computed: {

  },
  methods: {
    //token获取
    // async getToken() {
    //   let data = {
    //     appcode: '5101',
    //     secret: "C12WVzJzBLX1YVgekU995FjtVzJwOo"
    //   }
    //   const res = await api("get", "/v1/auth/getToken", data)
    //   let usertoken = res.data.data.access_token
    //   let timestamp = Math.round(new Date() / 1000)
    //   let tokenArr = [usertoken,timestamp]
    //   localStorage.setItem("token", JSON.stringify(tokenArr))
    //   // .then(res => {
    //   //   if (res.data.code == 1200) {

    //   //     // let usertoken = res.data.data.access_token;
    //   //     // let timestamp = Math.round(new Date() / 1000);
    //   //     // let tokenArr = [usertoken,timestamp]
    //   //     // localStorage.setItem("token", JSON.stringify(tokenArr))
    //   //   } else {
    //   //     this.$notify.error({
    //   //       title: '错误',
    //   //       message: '获取token失败'
    //   //     });
    //   //   }
    //   // })
    // },
    //获取列表数据
    getList() {
      let data = {
        pageNum: this.pages,
        pageSize: this.pageSize,
        istop: '0',
        classid: "511487",
        activitytype: ""
      }
      api("get", "/v1/app/listortop2", data)
        .then(res => {
          if (res.data.code == 1200) {
            this.listData = this.listData.concat(res.data.data)
          }
        })
    },
    lazyLoading() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight
      const scrollHeight = document.documentElement.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight) {
        // 滚动到底部，逻辑代码
        this.pages++
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.getList()
        }, 1000)
      }
    },
    //
    hanldeItem(id) {
      this.$router.push({
        path: "/item",
        query: {
          id: id
        }
      })
    }

  }
}
</script>
<style lang="less" scoped>
.mian {
  width: 100%;

  .header {
    width: 80%;
    height: 60px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .logo {
      font-size: 30px;
      font-family: '阿里妈妈东方大楷 Regular';
    }
  }

  .fgx {
    width: 100%;
    height: 3px;
    background-color: coral;
  }

  .listBox {
    width: 80%;
    margin: 0 auto;
    display: flex;
    margin-top: 30px;
    flex-wrap: wrap;

    .hoverBox {
      width: 25%;
      height: 290px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;

      .itemBox {
        width: 300px;
        height: 260px;

        .itemImg {
          width: 300px;
          height: 180px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .itemTitle {
          font-size: 18px;
          font-family: 'NSimSun';
          font-weight: bold;
          margin: 10px 0;
          margin-left: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-right: 30px;
        }

        .itemDate {
          font-size: 12px;
          color: #909399;
          margin-top: 5px;
          margin-left: 10px;
        }
      }

      &:hover {
        border: 1px solid #DCDFE6;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12),
          0 0 6px rgba(0, 0, 0, .04);

        .itemBox {
          background-color: #F7F7F7;
        }

        .itemTitle {
          color: #E6A23C;
        }
      }
    }
  }

  .load {
    width: 30%;
    height: 40px;
    margin: 0 auto;
    margin-bottom: 10px;
  }

  .footer {
    width: 100%;
    height: 100px;
    background-color: #000;
    padding-top: 30px;

    .as {
      width: 80%;
      height: 30px;
      margin: 0 auto;
      text-align: center;
      color: #fff;
      font-size: 14px;

      a {
        text-decoration: none;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        &:hover{
          color: #409EFF;
        }
      }
    }
  }

}
</style>
